import { useQuery } from '@tanstack/react-query';

import { useStatisticOptions } from '../store';

import { hydrateWithTranslations } from '@services/TranslatorService';
import { getAllTeamsQuery } from '@shared/queries/teams';
import { competitionId } from '@utilities/WindowContext';

export const useTeams = () => {
  const { options } = useStatisticOptions();

  const { data: teams } = useQuery({
    ...getAllTeamsQuery({
      competitionId,
      seasonYear: options.season,
      limit: 600,
    }),
    placeholderData: [],
    select: (data) =>
      data.map((c) => hydrateWithTranslations(c)).toSorted((a, b) => a.displayName.localeCompare(b.displayName)),
  });

  return { teams };
};
